const transitionDurationMs = 225;
const iguideWrapper = "_uxsi1yx3tae";
const section = "_uxssuqb7x2";
const iguide = "_uxsijbjeie";

export { iguide, iguideWrapper, section, transitionDurationMs };
import "./variant.standalone.style.linaria.module.css";
//# sourceMappingURL=variant.standalone.style.js.map
